import React from "react";

const Footer = () => {
  const salonAddress = "33 Wessel Road, Edenburg, Sandton, 2128";

  const openDirections = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords;
          const mapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${encodeURIComponent(salonAddress)}`;
          window.open(mapsUrl, "_blank");
        },
        () => {
          window.open(
            `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(salonAddress)}`,
            "_blank"
          );
        }
      );
    } else {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(salonAddress)}`,
        "_blank"
      );
    }
  };

  return (
    <footer
      className="pt-3 pb-2"
      style={{
        background: "#141211",
        color: "#ebe7db",
        borderTop: "3px solid #d4c4a8",
        fontFamily: "Inter,sans-serif",
        marginTop: "5vh"
      }}
    >
      <div className="container">
        <div className="row align-items-center g-2">
          {/* Brand and social */}
          <div className="col-12 col-md-7 mb-3 mb-md-0">
            <h4 className="fw-bold mb-1" style={{
              color: "#2c2c2c",
              letterSpacing: ".02em",
              fontSize: "1.2rem",
              fontFamily: "'Playfair Display',serif"
            }}>
              Zoteya
            </h4>
            <div style={{ fontSize: ".97rem", color: "#e3d6b9", fontWeight: 500 }}>
              Your premier destination for luxury beauty and hair services.<br />
              <span style={{ color: "#bdae8c" }}>Experience excellence in every visit.</span>
            </div>
            {/* Socials, compact */}
            <div className="d-flex gap-2 mt-2">
              <a href="https://www.instagram.com/zoteya_beauty?igsh=eDNzNWk1MjRnbWpl&utm_source=qr"
                className="btn rounded-circle border-0 p-0"
                style={{
                  width: 32, height: 32, background: "#2e2b28",
                  color: "#e3d6b9", fontSize: "1.35rem"
                }}
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://www.tiktok.com/@zoteya_beauty?_t=ZS-90W9pnkvasu&_r=1"
                className="btn rounded-circle border-0 p-0"
                style={{
                  width: 32, height: 32, background: "#2e2b28",
                  color: "#e3d6b9", fontSize: "1.35rem"
                }}
                aria-label="TikTok"
                target="_blank"
                rel="noopener noreferrer">
                <i className="bi bi-tiktok"></i>
              </a>
              <a href="https://wa.me/27817392001"
                className="btn rounded-circle border-0 p-0"
                style={{
                  width: 32, height: 32, background: "#2e2b28",
                  color: "#e3d6b9", fontSize: "1.35rem"
                }}
                aria-label="WhatsApp"
                target="_blank"
                rel="noopener noreferrer">
                <i className="bi bi-whatsapp"></i>
              </a>
            </div>
          </div>
          {/* Contact info */}
          <div className="col-12 col-md-5 mt-2 mt-md-0">
            <div className="small" style={{ color: "#e0d7c7", fontSize: ".95rem" }}>
              <button
                onClick={openDirections}
                className="btn btn-link p-0 text-decoration-none mb-1"
                style={{ color: "#e0d7c7", fontSize: ".96rem" }}
              >
                📍 33 Wessel Road, Edenburg, Sandton
              </button>
              <br />
              <a href="tel:+27817392001" className="d-inline-block mb-1 text-decoration-none" style={{ color: "#e0d7c7" }}>
                📞 081 739 2001
              </a>
              <br />
              <a href="mailto:lufunov@gmail.com" className="d-inline-block mb-1 text-decoration-none" style={{ color: "#e0d7c7" }}>
                ✉️ lufunov@gmail.com
              </a>
              <br />
              <span style={{ color: "#ccc7b8" }}>🕒 Tue–Sat: 8:30 AM–5:30 PM</span>
              <span style={{ color: "#d4c4a8", paddingLeft: 6 }}>Closed: Mon &amp; Sun</span>
            </div>
          </div>
        </div>
        {/* Bottom Bar: Policies */}
        <div
          className="border-top pt-3 mt-3 d-flex flex-column flex-md-row justify-content-between align-items-center small"
          style={{ borderTop: "1.5px solid #23201e" }}
        >
          <p className="mb-1 mb-md-0" style={{ color: "#e3d6b9", fontSize: ".97em" }}>
            &copy; 2025 Zoteya Beauty Salon. All rights reserved.
          </p>
          <div className="d-flex gap-3">
            <a href="/privacy-policy" className="text-decoration-none" style={{ color: "#d4c4a8" }}>
              Privacy Policy
            </a>
            <a href="/terms-of-service" className="text-decoration-none" style={{ color: "#d4c4a8" }}>
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
